export default () => {
  window.edeeshopPopup.close();
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/closeEsp.js